// extracted by mini-css-extract-plugin
export default {"formHeading":"oL-z","form":"pL-z","submitBtn":"qL-z","disabled":"rL-z","input":"sL-z","error":"tL-z","submitMsg":"uL-z","signIn":"vL-z"};